





































import { Component, Prop, Vue } from 'vue-property-decorator'
import { CopyProcessedRelatedPartsResult } from '@/models'

@Component
export default class CopyProcessedRelatedPartsResultModal extends Vue {
  @Prop({ default: null }) result!: CopyProcessedRelatedPartsResult | null
  @Prop({ default: '' }) message!: string
  @Prop({ default: true }) success!: boolean

  get fields() {
    return [
      { key: 'label', label: this.$t('product_detail.structure.copy_processed_related_parts_modal.field_label') },
      { key: 'value', label: this.$t('product_detail.structure.copy_processed_related_parts_modal.field_value'), class: 'text-right', tdClass: 'text-right' }
    ]
  }

  get rows() {
    if (!this.result) return []
    const t = (key: string) => this.$t(`product_detail.structure.copy_processed_related_parts_modal.${key}`)
    return [
      { label: t('filas_procesadas'), value: this.result.filasProcesadas ?? 0 },
      { label: t('directorios_origen_faltan'), value: this.result.directoriosOrigenFaltan ?? 0 },
      { label: t('filas_sin_patron'), value: this.result.filasSinPatron ?? 0 },
      { label: t('sin_ficheros_que_cuadren'), value: this.result.sinFicherosQueCuadren ?? 0 },
      { label: t('directorios_a_crear'), value: this.result.directoriosACrear ?? 0 },
      { label: t('ficheros_copiar'), value: this.result.ficherosCopiar ?? 0 },
      { label: t('copias_omitidas_existia'), value: this.result.copiasOmitidasExistia ?? 0 }
    ]
  }
}
